import { Model } from '@/models/Model';
import { htmlHasContent } from '@/support/Html';
export class StudentDocument extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'StudentDocument';
        this.$endpoint = '/student-documents';
        this.$fillable = [];
    }
}
export const hasRequiredBasicInfo = (document) => {
    return !!(document.title && document.title.trim()) && htmlHasContent(document.description);
};
export var StudentDocumentIncludes;
(function (StudentDocumentIncludes) {
    StudentDocumentIncludes["STATUS"] = "status";
    StudentDocumentIncludes["BLOCKS"] = "blocks";
    StudentDocumentIncludes["TEACHERS"] = "teachers";
    StudentDocumentIncludes["CREATED_BY"] = "created_by";
    StudentDocumentIncludes["STUDENT_SUBJECTS"] = "student_subjects";
    StudentDocumentIncludes["FILE"] = "file";
    StudentDocumentIncludes["DOCUMENTABLE"] = "documentable";
})(StudentDocumentIncludes || (StudentDocumentIncludes = {}));
